import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo.jsx';
import PremiumCard from '../ui/PremiumCard.jsx';

export const adminAuthInputLight =
  'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green/40';

export default function AdminAuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-page-dark bg-fixed px-4 py-16">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(103,178,53,0.15),transparent_45%)]" />

      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="mx-auto flex h-16 w-44 items-center justify-center rounded-2xl border border-white/15 bg-slate-950/60 p-2 ring-1 ring-brand-navy/40 backdrop-blur-sm">
            <BrandLogo className="max-h-12" alt="Coonaltragas" />
          </div>
          <h1 className="mt-6 font-display text-2xl font-bold text-white md:text-3xl">{title}</h1>
          {subtitle ? <p className="mt-3 text-sm text-white/85">{subtitle}</p> : null}
        </div>

        <PremiumCard variant="light">{children}</PremiumCard>

        {footer ? <div className="mt-6 text-center text-sm text-white/80">{footer}</div> : null}
      </div>
    </div>
  );
}

export function AdminAuthBackLink({ to = '/admin/login', children = 'Volver al inicio de sesión' }) {
  return (
    <Link to={to} className="font-medium text-brand-green hover:text-brand-green/90 hover:underline">
      {children}
    </Link>
  );
}
